<template>
  <div>
    <div class="page" v-if="addressList">
      <fixed-header title="收货地址" :left="true" />
      <div class="page-bd">
        <div class="addr-list">
          <template v-for="(item, index) in addressList">
            <div :key="index" class="item" @click="select(item)">
              <van-icon
                :class="{
                  'ic-check': true,
                  checked: item.id === (defaultAddress && defaultAddress.id),
                }"
                size="24px"
                name="circle"
              />
              <div class="detail">
                <div class="txt-1">
                  {{ item.destination + " " + (item.doorPlate || "") }}
                </div>
                <div class="txt-2">
                  {{ item.consigneeName }}
                  <span class="phone">{{ item.mobileDes }}</span>
                </div>
              </div>
              <i class="ic-edit" @click.stop="onEdit(item)"></i>
            </div>
          </template>
        </div>
        <div class="no-data" v-if="addressList.length === 0">
          <img :src="addressIcon" alt="" />
          <div class="font">您还未添加收货地址</div>
        </div>
      </div>
      <div class="page-ft">
        <div class="inner">
          <van-button class="btn" @click="onEdit()" type="default">+ 新增地址</van-button>
          <van-button
            class="btn btn-submit"
            type="primary"
            :loading="loading"
            loading-text="确认收货"
            @click="onSubmit()"
            >确认收货</van-button
          >
        </div>
      </div>
    </div>

    <div class="viewLoading" v-else>
      <van-loading />
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { mapState, mapMutations } from "vuex";
import { getAddress, getEquityProductDetails, orderReceiveRecordEntry } from "../../api";
import FixedHeader from "../../components/FixedHeader";
import { callAppHandler, isApp } from "../../utils";
import { Dialog, Button, Icon, Toast } from "vant";

Vue.use(Button).use(Dialog).use(Icon).use(Toast);
export default {
  components: {
    FixedHeader,
  },
  data() {
    return {
      addressList: null,
      loading: false,
      productData: null,
      goodsId: this.$route.query.goodsId,
      addressIcon: require("../../assets/imgs/no-data.png"),
    };
  },
  computed: {
    ...mapState(["userInfo", "defaultAddress"]),
  },
  mounted() {
    if (isApp()) {
      callAppHandler({
        type: "statusBar",
        params: {
          theme: "1",
        },
      });
    }

    if (this.goodsId) {
      this.getProductDetail(this.goodsId);
    }

    this.getAddressList().then(this.handleDefaultAddress);
  },

  methods: {
    ...mapMutations(["setDefaultAddress"]),

    getAddressList() {
      return getAddress({
        midMemberId: this.userInfo.memberId,
      }).then((res) => {
        this.addressList = res.data || [];
      });
    },

    // 处理默认选中的地址
    handleDefaultAddress() {
      if (!this.defaultAddress) {
        const defaultAddress =
          this.addressList && this.addressList.length && this.addressList[0];
        this.setDefaultAddress(defaultAddress);
      }
    },

    // 获取商品详情
    getProductDetail(equityProductid) {
      getEquityProductDetails({ equityProductid }).then((res) => {
        if (res.data && res.data.id) {
          this.productData = res.data || {};
        } else {
          Toast("该商品不存在");
          this.$router.go(-1);
        }
      });
    },

    // 选择地址
    select(data) {
      this.setDefaultAddress(data);
    },

    // 新增、编辑地址
    onEdit(item) {
      this.$router.push({
        name: "addAddressPage",
        query: { addressId: item ? item.id : "" },
      });
    },

    // 梳理表单
    handleFormData() {
      const addr = this.defaultAddress;
      const product = this.productData;

      if (!addr) {
        Toast(
          this.addressList && this.addressList.length > 0 ? "请选择地址" : "请添加地址"
        );
        return false;
      }

      if (!product) {
        Toast("商品信息缺失，请稍后重试");
        setTimeout(() => {
          this.$router.go(-1);
        }, 1000);
        return false;
      }

      let data = {
        orderSource: "PLUS_MEMBER", // 会员中心都传这个
        memberEquityType: this.$route.query.memberEquityType,
        equityId: this.$route.query.equityId,
        midMemberId: this.userInfo.memberId,
        // 地址相关
        provinceName: addr.provinceName,
        provinceCode: addr.provinceCode,
        cityName: addr.cityName,
        cityCode: addr.cityCode,
        districtName: addr.districtName,
        districtCode: addr.districtCode,
        destination: addr.destination,
        doorPlate: addr.doorPlate,
        longitude: addr.lon,
        latitude: addr.lat,
        sexType: addr.male ? "MALE" : "FEMALE",
        consigneeName: addr.consigneeName,
        mobile: addr.mobile,
        addressId: addr.id,
        // 商品相关
        priceType: product.priceType,
        goodsEntryReqVos: [
          {
            goodsActualPrice: product.priceValue,
            goodsCode: product.id,
            goodsImageUrl: product.icon,
            goodsOriginalPrice: product.priceValue,
            goodsType: product.productType,
            goodsNumber: 1,
          },
        ],
      };
      return data;
    },

    // 提交
    onSubmit() {
      const formData = this.handleFormData();
      if (this.loading || !formData) return;

      this.loading = true;
      orderReceiveRecordEntry(formData)
        .then((res) => {
          if (res.data && res.code === 200) {
            Toast.success("领取成功");
          } else {
            Toast(res.msg || "领取失败");
          }
          setTimeout(() => {
            this.$router.back();
          }, 800);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/style/main";
.page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  .page-bd {
    overflow: auto;
    flex: 1;
  }
  .page-ft {
    background: #fff;
    .inner {
      display: flex;
      flex-direction: column;
      margin: 10px 20px;
      .btn {
        width: 100%;
        font-size: 17px;
        border-radius: 40px;
        border-color: #dddddd;
      }
      .btn-submit {
        margin-top: 10px;
        margin-bottom: constant(safe-area-inset-bottom);
        margin-bottom: env(safe-area-inset-bottom);
        color: #fff;
        border-color: rgba(49, 124, 237, 1);
        background: rgba(49, 124, 237, 1);
      }
    }
  }
  .addr-list {
    padding-bottom: 20px;
    > .item {
      padding: 18px 10px;
      margin: 10px 10px 0 10px;
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 8px;
      .phone {
        margin-left: 15px;
      }
      .ic-check {
        width: 24px;
        color: #cecece;
        &:before {
          content: "\e692";
        }
        &.checked {
          color: #ff5722;
          &:before {
            content: "\e68d";
          }
        }
      }
      .detail {
        margin: 0 2px 0 10px;
        flex: 1;
        .txt-1 {
          line-height: 1.2;
          font-size: 15px;
        }
        .txt-2 {
          margin-top: 10px;
          font-size: 12px;
          color: #999;
        }
      }
      .ic-edit {
        padding: 12px;
        width: 15px;
        height: 15px;
        background: url(../../assets/imgs/ic_edit.png) center no-repeat;
        background-size: 15px;
        transform: translateX(8px);
      }
    }
  }
}

.viewLoading {
  margin: 50px auto;
  text-align: center;
}

.no-data {
  img {
    width: 406 / @baseSize;
    height: auto;
    margin: 200 / @baseSize auto 0 auto;
    display: block;
  }

  .font {
    margin-top: 32 / @baseSize;
    color: #999999;
    text-align: center;
    font-size: 26 / @baseSize;
  }
}
</style>
